import type { Consent } from "fhir/r4";
import { v4 as uuid } from "uuid";

import * as FHIRUtils from "../fhirutils";

export function build(
  patientId: string,
  effectiveDate: string,
  updatedBy: string
): Consent {
  const consentId = uuid();

  const consent: Consent = {
    resourceType: "Consent",
    id: consentId,
    status: "active",
    scope: {
      coding: [
        {
          system: "http://terminology.hl7.org/CodeSystem/consentscope",
          code: "patient-privacy",
          display: "Privacy Consent",
        },
      ],
    },
    category: [
      {
        coding: [
          {
            system: "http://terminology.hl7.org/CodeSystem/v3-ActCode",
            code: "IDSCL",
            display: "information disclosure",
          },
        ],
      },
    ],
    patient: {
      reference: "Patient/" + patientId,
    },
    dateTime: effectiveDate,
    policyRule: {
      coding: [
        {
          system: "http://terminology.hl7.org/CodeSystem/consentpolicycodes",
          code: "hipaa-auth",
          display: "HIPAA Authorization",
        },
      ],
    },
  };

  return FHIRUtils.addUpdatedBy(consent, updatedBy);
}
